// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gallery-item-activity-table[data-v-631af5d3]{overflow-y:auto}@media screen and (max-width:1023px){.gallery-item-activity-table[data-v-631af5d3] .o-table__td{border-bottom:inherit!important}}@media screen and (max-width:768px){.padding-top-mobile[data-v-631af5d3]{padding-top:0!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
